"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _AnalyticsDataInitialization = require("./AnalyticsDataInitialization");
Object.keys(_AnalyticsDataInitialization).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AnalyticsDataInitialization[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _AnalyticsDataInitialization[key];
    }
  });
});
